import styled from "styled-components"

export const Container = styled.div`
  position: relative;
  display: inline-block;
`

export const Trigger = styled.button<{ $viewing?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  background: ${(p) =>
    p.$viewing ? p.theme.colors.turquoiseLighter : p.theme.colors.white};
  color: ${(p) =>
    p.$viewing ? p.theme.colors.turquoiseDark : p.theme.colors.black};
  border: 0.1rem solid
    ${(p) =>
      p.$viewing ? p.theme.colors.turquoiseDark : p.theme.colors.greyLight};
  border-radius: 0.5rem;
  padding: 0 2rem;
  height: 4rem;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.turquoiseDark};
  }

  svg {
    width: 1.2rem;
    height: 1.2rem;
    fill: currentColor;
  }
`

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 0.4rem);
  left: 0;
  z-index: 10;
  min-width: 28rem;
  max-height: 36rem;
  overflow-y: auto;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.5rem;
  box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.08);
  padding: 0.4rem;
`

export const Row = styled.button<{ $active?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.7rem 0.8rem;
  background: ${(p) =>
    p.$active ? p.theme.colors.greyLightest : p.theme.colors.white};
  border: none;
  border-radius: 0.4rem;
  cursor: pointer;
  text-align: left;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.black};

  &:hover {
    background: ${(p) => p.theme.colors.greyLightest};
  }

  & + & {
    margin-top: 0.2rem;
  }
`

export const RowLabel = styled.span`
  ${(p) => p.theme.bold};
  font-family: monospace;
  min-width: 3rem;
`

export const RowMeta = styled.span`
  color: ${(p) => p.theme.colors.greyDarker};
  font-size: 1.1rem;
  flex: 1;
`

export const RowBadges = styled.span`
  display: inline-flex;
  gap: 0.4rem;
  align-items: center;
`

export const StatusBadge = styled.span<{ $published?: boolean; $draft?: boolean; $viewing?: boolean }>`
  font-size: 1rem;
  padding: 0.15rem 0.6rem;
  border-radius: 0.3rem;
  white-space: nowrap;
  background: ${(p) => {
    if (p.$published) return p.theme.colors.turquoiseDark
    if (p.$viewing) return p.theme.colors.turquoiseLighter
    if (p.$draft) return "#fef3c7"
    return p.theme.colors.greyLight
  }};
  color: ${(p) => {
    if (p.$published) return p.theme.colors.white
    if (p.$viewing) return p.theme.colors.turquoiseDark
    if (p.$draft) return "#92400e"
    return p.theme.colors.greyDarker
  }};
`

export const RestoreButton = styled.span`
  font-size: 1rem;
  padding: 0.25rem 0.7rem;
  border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};
  border-radius: 0.3rem;
  color: ${(p) => p.theme.colors.turquoiseDark};
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  ${(p) => p.theme.bold};

  &:hover {
    background: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.white};
  }
`

export const Empty = styled.div`
  padding: 1.2rem 0.8rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.greyDarker};
  text-align: center;
`
